/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Default_Catch_Boundary_DescriptionInputs */

const en_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We hit some turbulence rendering this page. Your funds aren’t affected — try again in a moment.`)
};

const de_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Laden dieser Seite gab es Turbulenzen. Ihr Guthaben ist nicht betroffen – versuchen Sie es gleich noch einmal.`)
};

const pt_br2_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontramos uma turbulência ao carregar esta página. Seus fundos não foram afetados — tente novamente em instantes.`)
};

const tr_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sayfa yüklenirken bir türbülans yaşadık. Fonlarınız etkilenmedi — birazdan tekrar deneyin.`)
};

const zh_cn2_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渲染此页面时出现了一些问题。您的资金不受影响，请稍后重试。`)
};

const zh_hk2_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`呈現此頁面時出現問題。你的資金不受影響 — 請稍後再試。`)
};

const ko_kr2_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지를 표시하는 중 문제가 발생했습니다. 자산에는 영향이 없으니 잠시 후 다시 시도해 주세요.`)
};

const ru_ru2_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При отрисовке этой страницы возникла турбулентность. На ваши средства это не влияет — повторите попытку через мгновение.`)
};

const es_419_components_default_catch_boundary_description = /** @type {(inputs: Components_Default_Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontramos turbulencia al mostrar esta página. Tus fondos no se ven afectados: inténtalo de nuevo en un momento.`)
};

/**
* | output |
* | --- |
* | "We hit some turbulence rendering this page. Your funds aren’t affected — try again in a moment." |
*
* @param {Components_Default_Catch_Boundary_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_default_catch_boundary_description = /** @type {((inputs?: Components_Default_Catch_Boundary_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Default_Catch_Boundary_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_default_catch_boundary_description(inputs)
	if (locale === "de") return de_components_default_catch_boundary_description(inputs)
	if (locale === "pt-BR") return pt_br2_components_default_catch_boundary_description(inputs)
	if (locale === "tr") return tr_components_default_catch_boundary_description(inputs)
	if (locale === "zh-CN") return zh_cn2_components_default_catch_boundary_description(inputs)
	if (locale === "zh-HK") return zh_hk2_components_default_catch_boundary_description(inputs)
	if (locale === "ko-KR") return ko_kr2_components_default_catch_boundary_description(inputs)
	if (locale === "ru-RU") return ru_ru2_components_default_catch_boundary_description(inputs)
	return es_419_components_default_catch_boundary_description(inputs)
});